import { recordAppError } from "@shared/utils/errors/errorLogger";
import { serializeStripeError } from "../stripe/stripe";

/**
 * Records a payment-related error with proper serialization for non-standard errors.
 * This wrapper ensures that Stripe SDK errors and other non-standard error objects
 * are properly serialized before being sent to error reporting systems like Sentry.
 *
 * @param error - The error to record (can be Error, Stripe SDK error, or any other type)
 */
export function recordPaymentError(error: unknown): void {
  // If it's already a standard Error instance, pass it through as-is
  if (error instanceof Error) {
    recordAppError(error);
    return;
  }

  // For non-standard errors (like Stripe SDK errors), wrap them in a proper Error object
  // with the serialized data in the cause property
  const recordableError = new Error("Non-standard payment error captured", {
    cause: serializeStripeError(error),
  });

  recordAppError(recordableError);
}
